import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import useConfig from "../../../actions/Tenants/config/configHook";
import { CreateDeviceData, useCreateDeviceMutation } from "../../../hooks/useDeviceMutations";
import MetaForm from "../../Forms/MetaForm";

const CreateDeviceButton = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [query, setQuery] = useState<CreateDeviceData>({});
    const config = useConfig();
    const createDeviceMutation = useCreateDeviceMutation();

    const form = [
        {
            label: "Device Name",
            type: "text",
            name: "name",
            required: true,
        },
        {
            label: "Device Type",
            type: "single-select",
            name: "type",
            required: true,
            options: [
                { label: "Mini", value: "mini" },
                { label: "Tablet", value: "fta" },
                { label: "Ripening Room Gateway", value: "ripening_room_gateway" },
                { label: "Ripetap", value: "ripetap" },
            ],
        },
        {
            label: "Device UID",
            type: "text-qrcode-scanner",
            name: "UID",
            required: true,
        },
        {
            label: "Fruit Type",
            type: "select-managed",
            name: "fruit_type",
        }

    ];

    const handleCreateDevice = () => {
        // Validate required fields
        if (!query.name || !query.UID || !query.type) {
            return;
        }

        createDeviceMutation.mutate({
            name: query.name,
            UID: query.UID,
            type: query.type,
            fruit_type: query.fruit_type || undefined,
        });
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setQuery({});
    };

    return (
        <>
            <Button key="button" color="primary" onClick={() => setModalOpen(true)}>Create Device</Button>

            <Modal key="modal" isOpen={modalOpen} toggle={handleCloseModal}>
                <ModalHeader>Create Device</ModalHeader>

                <ModalBody>
                    <MetaForm meta={form} object={query} setValue={(field, value) => setQuery((prev) => ({ ...prev, [field]: value }))} config={config} />
                </ModalBody>

                <ModalFooter>
                    <Button color="secondary" onClick={handleCloseModal}>Cancel</Button>

                    <Button
                        color="primary"
                        onClick={handleCreateDevice}
                        disabled={createDeviceMutation.isPending || !query.name || !query.UID || !query.type}
                    >
                        {createDeviceMutation.isPending ? "Creating..." : "Create"}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default CreateDeviceButton;
